// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d0f7aee5","513":"e8f7363d","787":"807fc67b"}[chunkId] + ".chunk.js";
};